import {Component} from 'react'

class HidingElement extends Component {
    render() {
        if (this.props.enabled) return this.renderIfEnabled()
        else return null
    }
}

export default HidingElement